<template>
  <div class="page-container">
    <h3 class="sub-heading">Are you sure you want to quit?</h3>
    <p>You will not be able to undo this</p>
    <div class="btn-group">
      <button class="btn-group__btn" @click="confirmExit">Yes, quit</button>
      <button class="btn-group__btn" @click="cancelExit">Cancel</button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    cancelExit() {
      this.$router.back();
    },
    confirmExit() {
      this.$store.dispatch('clearCurrentQuest');
      this.$router.push('/');
    },
  },
};
</script>
